import React, {
	ReactNode, createContext, useContext,
} from 'react';

const StoreContext = createContext(null);

export function useStore() {
	return useContext(StoreContext);
}

interface StoreProviderProps {
	store: any;
	children: ReactNode;
}

export default function StoreProvider({ children, store }: StoreProviderProps) {
	return (
		<StoreContext.Provider value={store}>
			{children}
		</StoreContext.Provider>
	);
}
